import React, { useEffect, useRef, useState } from 'react'

import TmoH4 from '../../tmoControlWrappers/TmoH4'
import classNames from 'classnames'
import style from './ExpandableText.module.css'

const ExpandableText = ({
  className,
  label,
  triggerText,
  closeText,
  triggerIcon,
  innerHeading,
  theme,
  isNavigationMenu,
  hasRef,
  boldLabel = false,
  customText,
  noHover,
  customIcon,
  expanded = false,
  testId,
  ...props
}) => {
  const [hasExpanded, setHasExpanded] = useState(false)
  const ref = useRef()
  useOnClickOutside(ref, () => setHasExpanded(false))

  function useOnClickOutside(ref, handler) {
    useEffect(() => {
      if (hasRef) {
        const listener = (event) => {
          if (!ref.current || ref.current.contains(event.target)) {
            return
          }
          handler(event)
        }
        document.addEventListener('mousedown', listener)
        return () => {
          document.removeEventListener('mousedown', listener)
        }
      }
    }, [ref, handler])
  }

  return (
    <div
      ref={ref}
      className={classNames(
        style.container,
        hasExpanded && style.expanded,
        style[theme],
        className
      )}
    >
      <label className={classNames(style.label, boldLabel && style.label_bold)}>
        {label}
        <button
          className={classNames(
            style.trigger,
            noHover ? style.no_bg : '',
            style.custom_btn
          )}
          onClick={() => setHasExpanded(!hasExpanded)}
        >
          {!hasExpanded && closeText
            ? customText
              ? customText
              : triggerText
            : closeText}
          {!closeText
            ? customIcon
              ? hasExpanded
                ? customIcon.arrowUp
                : customIcon.arrowDown
              : triggerText
            : null}
          {triggerIcon && (
            <span className={style.trigger_icon}>{triggerIcon}</span>
          )}
        </button>
      </label>

      {hasExpanded && (
        <div className={style.content} data-testid={testId}>
          <div className={style.content_inner}>
            {innerHeading && (
              <TmoH4 className={style.content_inner_heading}>
                {innerHeading}
              </TmoH4>
            )}
            {isNavigationMenu ? (
              <span onClick={() => setHasExpanded(false)}>
                {props.children}
              </span>
            ) : (
              <React.Fragment>{props.children}</React.Fragment>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ExpandableText
